import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import logo from './logo.png';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    root: {
        flexGrow: 1,
        marginBottom: '10px'
    },
    flex: {
        flex: 1
    },
    logo: {
        marginLeft: '10px',
        width: '100px'
    }
};

function Header(props) {
    const { classes } = props;

    return (
        <div className={classes.root}>
            <AppBar position="static" color="primary">
                <Toolbar>
                    <Typography
                        variant="title"
                        color="inherit"
                        className={classes.flex}
                    >
                        Signature Generator
                    </Typography>
                    <img src={logo} className={classes.logo} alt="logo" />
                </Toolbar>
            </AppBar>
        </div>
    );
}

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/Header.js